// import helper from '@/_libs/helper';

import user from './_user';
import history from './_history';
import customer from './_customer';
import sellRecord from './_sell-record';

const CS_API = {
  user,
  history,
  customer,
  sellRecord,
};

export default {
  // ...helper,
  ...CS_API,
};
